import { NSARouterMakerProps, NSAHomePage } from "namirasoft-account-react";
import { CredentialLayout } from '../CredentialLayout';
import { ProductUUID } from "namirasoft-api-product";

interface HomePageProps extends NSARouterMakerProps
{ }

function HomePage(props: HomePageProps) 
{
	return (
		<CredentialLayout {...props}
			action={{ menus: {} }}
		>
			<NSAHomePage
				product_id={ProductUUID.NAMIRASOFT_CREDENTIAL}
				notifier={props.notifier}
			/>
		</ CredentialLayout >
	);
};

export default HomePage;